// material ui
import Stack from '@mui/material/Stack';

// project import
import {CircularWithPath} from './@extended';

// ==============================|| LOADER - CIRCULAR ||============================== //

export const CircularLoader = () => {
    return (
        <Stack alignItems="center" justifyContent="center" sx={{height: '100%'}}>
            <CircularWithPath />
        </Stack>
    );
};

export default CircularLoader;
